import { render } from "./AiContinuousGlobe.vue?vue&type=template&id=025d7333&scoped=true&ts=true"
import script from "./AiContinuousGlobe.vue?vue&type=script&lang=ts"
export * from "./AiContinuousGlobe.vue?vue&type=script&lang=ts"

import "./AiContinuousGlobe.vue?vue&type=style&index=0&id=025d7333&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-025d7333"]])

export default __exports__